export const DESIGN_SYSTEM_DEMO_PAGE =
  'designSystemDemo/DESIGN_SYSTEM_DEMO_PAGE'
